

import Vue from "vue";
import { Contact } from "@/models/base";

export default Vue.extend({
	props: {
		contact: {type: Object as () => Contact},
	},
	computed: {
		text(){
			return this.contact.Info.replaceAll("{__NEW_LINE__}","<br>").replaceAll("{__DOUBLE_SPACE__}", "&nbsp;&nbsp;").replace(/(?:\r\n|\r|\n)/g, "<br>");
		}
	},
	methods: {

	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
